import Splide from '@splidejs/splide';

export default function () {
	const splideContainer = document.querySelector('.recipe-carousel-splide');
	if (splideContainer !== null) {
		var splide = new Splide( '.recipe-carousel-splide', {
			arrows: true,
			pagination: false,
			autoplay: true,
			interval: 5000,
			type: 'loop',
			pauseOnHover: true,
			pauseOnFocus: true,
			autoHeight: true,
		} );
		if (splide === null) {
			return;
		} else {
			splide.mount();
		}
	}
}
